class SearchStringOrIntReq {
    constructor(){
        this.SearchString = undefined;
        this.SearchInt = undefined;
        this.SearchIntegers = undefined;
        this.HoursIndex = undefined;
        this.SearchDate = undefined;
        this.EndDate = undefined;
        this.StartDate = undefined;
        this.IsDummy = false;
        this.pagingParams = {
            pageNumber : undefined,
            pageSize : undefined
        }
    }
}

export default SearchStringOrIntReq;